import Typography from "@material-ui/core/Typography";

const ActivationConfirmStep = () => {
    return (
       <Typography variant='body1'>
           La richiesta è stata presa in carico, verrà gestita entro le tempistiche previste
       </Typography>
    )
}

export default ActivationConfirmStep;
